var map = {
	"./ar/label.json": "./src/locales/ar/label.json",
	"./cz/label.json": "./src/locales/cz/label.json",
	"./de/label.json": "./src/locales/de/label.json",
	"./en/label.json": "./src/locales/en/label.json",
	"./es/label.json": "./src/locales/es/label.json",
	"./fr/label.json": "./src/locales/fr/label.json",
	"./hr/label.json": "./src/locales/hr/label.json",
	"./ja/label.json": "./src/locales/ja/label.json",
	"./ko/label.json": "./src/locales/ko/label.json",
	"./kz/label.json": "./src/locales/kz/label.json",
	"./pt/label.json": "./src/locales/pt/label.json",
	"./sh/label.json": "./src/locales/sh/label.json",
	"./sr/label.json": "./src/locales/sr/label.json",
	"./sv/label.json": "./src/locales/sv/label.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales sync recursive ^\\.\\/.*\\/label\\.json$";